/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Morse code translator. Convert text to Morse code and decode Morse back to text. Runs in your browser.`)
};

const es_mc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traductor gratuito de código Morse. Convierta texto a código Morse y decodifique Morse de nuevo a texto. Se ejecuta en su navegador.`)
};

const de_mc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Morsecode-Übersetzer. Wandle Text in Morsecode um und dekodiere Morse zurück in Text. Läuft direkt in deinem Browser.`)
};

const nl_mc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis morsecode-vertaler. Converteer tekst naar morsecode en decodeer morse terug naar tekst. Draait in uw browser.`)
};

const fr_mc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traducteur de code Morse gratuit. Convertissez du texte en code Morse et décodez Morse en texte. Fonctionne dans votre navigateur.`)
};

const it_mc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduttore gratuito di codice Morse. Converti il testo in codice Morse e decodifica il Morse di nuovo nel testo. Funziona nel tuo browser.`)
};

const pt_br2_mc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradutor de código Morse grátis. Converta texto em código Morse e decodifique Morse de volta para texto. Funciona no seu navegador.`)
};

const pt_mc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradutor de código Morse gratuito. Converta texto em código Morse e decodifique Morse de volta para texto. Funciona no seu navegador.`)
};

const ja_mc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のモールス信号翻訳ツール。テキストをモールス信号に変換し、モールス信号をテキストにデコードできます。ブラウザで実行されます。`)
};

const zh_mc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的摩尔斯电码翻译器。将文本转换为摩尔斯电码，并将摩尔斯电码解码回文本。在您的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_tool_description", locale)
	if (locale === "en") return en_mc_tool_description(inputs)
	if (locale === "es") return es_mc_tool_description(inputs)
	if (locale === "de") return de_mc_tool_description(inputs)
	if (locale === "nl") return nl_mc_tool_description(inputs)
	if (locale === "fr") return fr_mc_tool_description(inputs)
	if (locale === "it") return it_mc_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_mc_tool_description(inputs)
	if (locale === "pt") return pt_mc_tool_description(inputs)
	if (locale === "ja") return ja_mc_tool_description(inputs)
	return zh_mc_tool_description(inputs)
};